// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-role-extended-rights-description-card .mat-mdc-card {
  max-width: 350px;
  border-radius: 10px;
}
.fi-role-extended-rights-description-card .mat-mdc-card.extra-margin {
  margin-top: 20px;
}
.fi-role-extended-rights-description-card .mat-mdc-card .mat-mdc-card-title {
  font-size: 20px;
  margin-bottom: 8px;
}
.fi-role-extended-rights-description-card .mat-mdc-card .card-section {
  margin-bottom: 20px;
  font-size: 14px;
}
.fi-role-extended-rights-description-card .mat-mdc-card .card-section .no-margin {
  margin-bottom: 0;
}
.fi-role-extended-rights-description-card .mat-mdc-card .card-section {
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./Source/app/role/role-new-layout/role-extended-rights/role-extended-rights-description-card/role-extended-rights-description-card.component.scss","webpack://./Source/app/shared/fi-shared-styles/fi-two-columns-info-card-mixin.scss"],"names":[],"mappings":"AAGI;ECFA,gBAAA;EACA,mBAAA;ADCJ;ACCI;EACI,gBAAA;ADCR;ACEI;EACI,eAAA;EACA,kBAAA;ADAR;ACGI;EACI,mBAAA;EACA,eAAA;ADDR;ACGQ;EACI,gBAAA;ADDZ;AAXQ;EACI,eAAA;AAaZ","sourcesContent":["@use '../../../../shared/fi-shared-styles/fi-two-columns-info-card-mixin';\r\n\r\n.fi-role-extended-rights-description-card {\r\n    .mat-mdc-card {\r\n        @include fi-two-columns-info-card-mixin.fi-two-columns-info-card();\r\n\r\n        .card-section {\r\n            font-size: 14px;\r\n        }\r\n    }\r\n}\r\n","@mixin fi-two-columns-info-card() {\r\n    max-width: 350px;\r\n    border-radius: 10px;\r\n\r\n    &.extra-margin {\r\n        margin-top: 20px;\r\n    }\r\n\r\n    .mat-mdc-card-title {\r\n        font-size: 20px;\r\n        margin-bottom: 8px;\r\n    }\r\n\r\n    .card-section {\r\n        margin-bottom: 20px;\r\n        font-size: 14px;\r\n\r\n        .no-margin {\r\n            margin-bottom: 0;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
